import { Component, EventEmitter, Input, Optional, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalComponent } from "@app/shared/components";
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import { Log } from 'ng2-logger';
import { Subscription, Observable, timer } from "rxjs";
import { take } from "rxjs/operators";
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-logout-modal',
    templateUrl: './logout-modal.component.html',
    styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent {
    _logger = Log.create(LogoutModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() infoMessage: string;
    @Input() timer: number;
    @Input() redirectToHome = true;
    @Input() externalLogoutHandling = false;
    @Input() autoZIndex = false;
    @Input() baseZIndex = 999;

    @Output() continue = new EventEmitter<any>();
    @Output() timeout = new EventEmitter<void>();

    counter$: Observable<number>;
    counterSubscription: Subscription = new Subscription();

    countdown: number;
    private initialTimer: number;
    private skipContinueEmit = false;

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        @Optional() private msalService: MsalService
    ) {
    }

    open() {
        this.modal.open();
        this.initialTimer = this.timer;
        this.countdown = this.timer;
        this.counter$ = timer(0, 1000).pipe(take(this.initialTimer));

        this.counterSubscription = this.counter$.subscribe((x) => {
            const timr = --this.countdown;
            this.countdown = timr;
            if (timr === 0) {
                this.skipContinueEmit = true;
                if (this.externalLogoutHandling) {
                    this.timeout.emit();
                } else {
                    this.onLogout();
                }
                this.close();
            }
        })
    }

    close(emitContinue = true) {
        this.modal.close();
        if (this.counterSubscription) {
            this.counterSubscription.unsubscribe();
        }
        this.countdown = this.initialTimer;
        if (this.redirectToHome) {
            this.router.navigate(['']);
        } else if (emitContinue && !this.skipContinueEmit) {
            this.continue.emit();
        }
        this.skipContinueEmit = false;
    }

    onLogout() {
        this._logger.info('onLogout:: ');

        // Check if user authenticated via legacy auth (read before clearing storage)
        const isLegacyAuth = this.authService.isLegacyAuth();

        // Always notify server about logout
        this.authService.logout().subscribe({
            next: (data) => {
                this._logger.info('onLogout:: Server logout successful.', data);
            },
            error: (error) => {
                this._logger.error('onLogout:: Server logout failed.', error);
            },
            complete: () => {
                // Clear storage after server is notified
                this.authService.clearAuthStorage();

                if (environment.msalEnable && this.msalService && !isLegacyAuth) {
                    // Use MSAL logout redirect
                    this.msalService.logoutRedirect({
                        postLogoutRedirectUri: this.authService.getMsalRedirectUri()
                    });
                } else {
                    // Legacy logout - navigate to auth
                    this.router.navigate(['auth']);
                }
            }
        });
    }
}
